import { MutableRefObject, useEffect, useState } from "react"
import styled from "styled-components"

const StyledContainer = styled.div<{ hidden: boolean }>`
  display: ${(p) => (p?.hidden ? "none" : "block")};
  // justify-content: center;

  position: fixed;
  z-index: 1500;
  margin: 0 auto;
  width: 100%;

  ${(p) => p.theme.breakpoints.down("sm")} {
    top: 10px;
  }
`

const StyledNavContainer = styled.div`
  padding: 15px;
  background: ${(p) => p.theme.colors.grey};
  border: 3px solid ${(p) => p.theme.colors.cherryRed};
  border-radius: 3px;
`

const StyledDescription = styled.p`
  text-align: center;
  font-size: 25px;
  margin: 0;
  padding: 0;
`

type KeyboardNavProps = {
  refList: MutableRefObject<HTMLDivElement>[]
}

const KeyboardNavigation = ({ refList }: KeyboardNavProps) => {
  const [hideNav, setHideNav] = useState(true)
  // Ensures that this component will only show once
  const [seenOnce, setSeenOnce] = useState(false)

  useEffect(() => {
    function handleKeyDown(e) {
      if (!e?.key || seenOnce) return

      if (e.key === "Tab") {
        e.preventDefault()

        if (hideNav) {
          setHideNav(false)
          return
        }

        if (!hideNav) {
          setSeenOnce(true)
          setHideNav(true)
          return
        }
      }

      if (!hideNav && e.key === "Enter") {
        refList[0]?.current?.scrollIntoView()
        refList[0]?.current?.focus()
        setSeenOnce(true)
        setHideNav(!hideNav)
      }

      // Old code that allowed you to navigate to different blocks
      // matches digits 0 - 9
      // if (!hideNav && e.key.match(/^\d+$/)) {
      // refList[e.key - 1]?.current?.scrollIntoView()
      // refList[e.key - 1]?.current?.focus()
      // }
    }

    document.addEventListener("keydown", handleKeyDown)

    // Clean up event
    return function cleanup() {
      document.removeEventListener("keydown", handleKeyDown)
    }
  }, [hideNav])

  return (
    <StyledContainer hidden={hideNav}>
      <StyledNavContainer>
        <StyledDescription>דלג לתוכן</StyledDescription>
      </StyledNavContainer>
    </StyledContainer>
  )
}

export default KeyboardNavigation
